function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import { useAppContext } from "../Providers";
import useCefNavigation from "./useCefNavigation";
import MarketsContext from "../Providers/Markets/MarketsContext";
import { useContext } from 'react';
import { useEducationLevels, useEducationLevelFamilyTypes, useFieldsOfEducation, useMarketPreferences, useStudentPreferences } from "../../../data";
import { useCefEventTracker } from "./useCefEventTracker";
import { getFieldsOfEducationIdCategory, getFieldsOfEducationIdSubcategory } from "../../StudentOnboarding/storage/FieldsOfEducation/localStorage";
import { getStoredIntakes } from "../../StudentOnboarding/storage/Intakes/localStorage";
import { formatPayload } from "../Utilities/ResultsHelper";
import { studentOnboarding } from "../../controller/consts";
import { Routes } from "../Common/Constants";
import { CefEvent, CefEventName, Platform } from "../../../EventTracker";
import { EligibilityAnswers } from "../../../models/Eligibility";
import { goToSearchPage } from "../../../helpers";
import { useFieldsOfStudyParamMapping } from "../../../hooks";
import { useRPSearchParams } from "../../../models/RPSearchParams";
export var useFooterButtonRedirect = function useFooterButtonRedirect(_ref) {
  var _userIdNum$toString;
  var application = _ref.application,
    shouldNavigateToRoute = _ref.shouldNavigateToRoute,
    shouldNavigateToApplyBoostPathwayPage = _ref.shouldNavigateToApplyBoostPathwayPage,
    route = _ref.route,
    state = _ref.state;
  var _useAppContext = useAppContext(),
    onSubmit = _useAppContext.onSubmit,
    programId = _useAppContext.programId,
    userIdNum = _useAppContext.userId;
  var userId = (_userIdNum$toString = userIdNum === null || userIdNum === void 0 ? void 0 : userIdNum.toString()) !== null && _userIdNum$toString !== void 0 ? _userIdNum$toString : null;
  var navigate = useCefNavigation();
  var _useStudentPreference = useStudentPreferences(userId, {
      enabled: Boolean(userId)
    }),
    studentPreferences = _useStudentPreference.studentPreferences;
  var _useContext = useContext(MarketsContext),
    marketsData = _useContext.data;
  var _useMarketPreferences = useMarketPreferences(userId, {
      enabled: Boolean(userId) && !programId
    }),
    marketPreferences = _useMarketPreferences.marketPreferences;
  var _useFieldsOfEducation = useFieldsOfEducation(),
    fieldsOfEducationData = _useFieldsOfEducation.fieldsOfEducationData;
  var fieldsOfEducation = useFieldsOfStudyParamMapping(studentPreferences.fieldOfEducation, fieldsOfEducationData);
  var _useEducationLevels = useEducationLevels(),
    educationLevels = _useEducationLevels.educationLevels;
  var _useEducationLevelFam = useEducationLevelFamilyTypes(),
    educationLevelFamilyTypes = _useEducationLevelFam.educationLevelFamilyTypes;
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent;
  var _useRPSearchParams = useRPSearchParams(),
    convertAnswersToSearchParams = _useRPSearchParams.convertAnswersToSearchParams;
  return function () {
    if (route && shouldNavigateToRoute) {
      navigate(route);
      return;
    }

    // add the tracking for show results here
    trackEvent({
      event: "".concat(studentOnboarding, " - CEF: ").concat(CefEventName.ClickedShowResultTitlecase),
      group: studentOnboarding
    });
    if (shouldNavigateToApplyBoostPathwayPage) {
      navigate(Routes.ApplyBoost.PathwayPage);
      return;
    }
    if (onSubmit) {
      // coming from quick_search
      trackEvent(CefEvent(CefEventName.ClickedShowResultOnSearch, Platform.Mobile));
      var anonStudentPreferences = _objectSpread(_objectSpread({}, studentPreferences), {}, {
        fieldOfEducation: [].concat(_toConsumableArray(getFieldsOfEducationIdCategory()), _toConsumableArray(getFieldsOfEducationIdSubcategory())),
        intakes: _toConsumableArray(getStoredIntakes())
      });
      var data = formatPayload(application, marketsData, marketPreferences, userId ? studentPreferences : anonStudentPreferences, educationLevels, educationLevelFamilyTypes, fieldsOfEducationData);
      onSubmit(data);
    } else {
      // coming from student dashboard
      trackEvent(CefEvent(CefEventName.ClickedExploreOtherPrograms, Platform.Mobile));
      var eligibilityAnswers = EligibilityAnswers.fromDsjState(state);
      var params = convertAnswersToSearchParams(_objectSpread({
        budget: studentPreferences.budget,
        countries: marketPreferences !== null && marketPreferences !== void 0 ? marketPreferences : null,
        fieldsOfEducation: fieldsOfEducation,
        programLevelFamilies: studentPreferences.programLevelFamily,
        intakes: studentPreferences.intakes
      }, eligibilityAnswers));
      goToSearchPage({
        searchParams: params
      });
    }
  };
};